import React, { useState, useRef } from "react";
import SectionHeading from "./sectionHeading";
import ContainerCard from "./containerCard";
import { Button, Input } from "@speedoc/design-assets";
import sendEmail from "../../utils/sendEmail";
import { trackCustom } from "../../services/analytics";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import useBrowserType from "../../hooks/useBrowserType";
import SubmissionConfirmation from "./submissionConfirmation";
import { GlobalStore } from "../../stores/global";

export default function ContactForm({ content }) {
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);
  const { isFirefox, isChrome } = useBrowserType();

  const initialState = {
    phone: "",
    name: "",
    date: ""
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formHasErrors, setFormHasErrors] = useState(false);
  const [fieldsMissing, setFieldsMissing] = useState({ name: false, phone: false, date: false });
  const [formHeight, setFormHeight] = useState(undefined);
  const [formData, setFormData] = useState(initialState);
  const targetRef = useRef();
  const { title, subtitle, emailFrom, emailTo, parent, fields, subject } = content;
  const formInfo = { fields, emailFrom, parent, subject, emailTo };
  const [error, setError] = useState(false);

  const isChromeOrFirefox = () => {
    return isChrome || isFirefox;
  };

  const handleInputChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleDateChange = e => {
    setFormData({ ...formData, date: e });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError(false);
    setIsSubmitting(true);
    setFieldsMissing({ name: false, phone: false, date: false });
    if (formData.date !== "" && formData.phone !== "" && formData.name !== "") {
      try {
        await sendEmail(formData, formInfo);
        setFormHeight(targetRef.current.offsetHeight);
      } catch (err) {
        console.log(err);
      } finally {
        trackCustom("Schedule", countryCode, { phone: formData.phone, name: formData.name, date: formData.date });
        setIsSubmitting(false);
        setError(false);
        setFormHasErrors(false);
        setIsSubmitted(true);
        setFormData({ ...initialState });
      }
    } else {
      setFieldsMissing({ phone: formData.phone === "", date: formData.date === "", name: formData.name === "" });
      setIsSubmitting(false);
      setFormHasErrors(true);
    }
  };

  const handleBackClick = () => {
    setIsSubmitted(false);
  };

  return (
    <div className="contactFormTime" id="contactFormAnchor">
      {title && <SectionHeading title={title} subtitle={subtitle} />}
      <ContainerCard>
        {!isSubmitted ? (
          <div className="container" ref={targetRef}>
            <div className="textSection">
              <div className="title">{content?.sectionTitle}</div>
              <div className="description">{content?.description}</div>
            </div>
            <form className="formSection">
              <Input
                className={`sm ${isChromeOrFirefox() ? "" : "margin-bottom"} ${
                  fieldsMissing.name ? "input-error" : ""
                }`}
                required
                id="name"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleInputChange}
              />
              <Input
                className={`sm ${fieldsMissing.phone ? "input-error" : ""}`}
                required
                id="phone"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleInputChange}
              />
              <div className="datePickers">
                <DatePicker
                  placeholderText="Preferred Date"
                  name="date"
                  selected={formData.date}
                  onChange={handleDateChange}
                  className={`date ${fieldsMissing.date ? "input-error" : ""}`}
                  popperClassName="popper"
                />
                <DatePicker
                  placeholderText="Preferred Time"
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                  name="time"
                  selected={formData.date}
                  onChange={handleDateChange}
                  className={`time ${fieldsMissing.date ? "input-error" : ""}`}
                />
              </div>
            </form>
            <div className="buttonSection">
              <Button onClick={handleSubmit} disabled={isSubmitting} className="primary sm">
                {isSubmitting ? "Please wait..." : content.buttonText}
              </Button>
              {formHasErrors ? <p className="errorMessage">Please fill in the required fields.</p> : null}
              {error ? <p className="errorMessage">{error}</p> : null}
            </div>
          </div>
        ) : (
          <SubmissionConfirmation formHeight={formHeight} handleBackClick={handleBackClick} />
        )}
      </ContainerCard>
    </div>
  );
}
